import React from 'react';
import { connect } from 'react-redux';
import ButtonLink from 'components/ButtonLink';
import { payrollExportsPayloadRequested } from 'services/payrollExports/actions';

interface OwnProps {
    id: number;
}

interface DispatchProps {
    downloadTimesheetSubmissions: typeof payrollExportsPayloadRequested;
}

export interface Props extends OwnProps, DispatchProps {}

export class TimesheetSubmissionsDownloadLinkComponent extends React.PureComponent<
    Props
> {
    public handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
        event.stopPropagation();

        const { downloadTimesheetSubmissions, id } = this.props;

        downloadTimesheetSubmissions(id);
    };

    public render(): JSX.Element {
        return <ButtonLink onClick={this.handleClick}>Download</ButtonLink>;
    }
}

export default connect(null, {
    downloadTimesheetSubmissions: payrollExportsPayloadRequested
})(TimesheetSubmissionsDownloadLinkComponent);
